







import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import VBarItem from '@/components/report/item/VBarItem.vue';

@Component({
  name: 'VBarItemList',
  components: { VBarItem }
})
export default class VBarItemList extends Vue {
  @Prop({ required: true }) rpList?: any[];
  @Prop({ required: false }) header?: boolean;
}
